<template>
    <div class="modal fade" id="statusModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content modal_wrapper">
                <div class="modal-header justify-content-between align-items-center border-0 mx-4">
                    <h3 class="modal-title">{{ $t("status.status") }}</h3>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body mx-auto">
                    <StatusSelector
                        :record="guestbook"
                        statusType="guestbook"
                        modalId="statusModal"
                        :getUrl="`/${$route.params.slug}/statuses?model=guestbook`"
                        :submitUrl="`/${$route.params.slug}/guestbooks/${guestbook.id}/status/edit`"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import StatusSelector from '@/components/StatusSelector.vue';

    export default {
        components: {
            StatusSelector,
        },
        props: {
            guestbook: Object,
        },
    }
</script>

<style scoped>
    .status_icon {
        width: 40px;
        height: 40px;
    }
</style>